export default {"src":"/_next/static/media/flour.4a0e506a.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};